import CatalogSectionContainer from "./CatalogSectionContainer.jsx";

export default function ArrivesPage() {
    return <CatalogSectionContainer kind="restocked" />;
}
